import React, { useState, memo } from 'react';
import { styled } from 'dripsy';
import { isNative } from 'app/styles';
import { TouchableOpacity, View as RView, Text as RText } from 'react-native';
import { ButtonText } from './text';

const cursor = !isNative ? { cursor: 'pointer', userSelect: 'none' } : {};

const buttonShadow = (p) => {
  return p.hover && !p.active && !p.disabled
    ? {
        boxShadow: '0 2px 6px hsl(240,0%,70%);',
      }
    : {};
};

export const Touchable = TouchableOpacity;

const button = {
  ...cursor,
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  height: 7,
  minWidth: [15 * 8, 18 * 8],
  px: 2,
};

// @ts-ignore
export const TextButton = styled(RText)({
  ...cursor,
  color: 'blue',
});

// @ts-ignore
export const StaticButton = styled(RView)((p: any) => ({
  ...button,
  bg: p.disabled ? 'grey' : 'blue',
  color: 'white',
  ...buttonShadow(p),
}));

interface HBProps {
  children: any;
  onPress?: (event: any) => void;
  onClick?: (event: any) => void;
  disabled?: boolean;
  sx: any;
  textSx?: any;
}

export const HoverButton = memo(HB);

function HB({ children, onPress, disabled = false, sx, textSx }: HBProps) {
  const [hover, setHover] = useState(false);
  const [active, setActive] = useState(false);
  const isString = typeof children === 'string';
  const isArray = typeof children === 'object' && children.length;
  const isTextArray = isArray && children.find((el) => typeof el === 'string');
  const renderString =
    !children || (!isArray && !children.$$typeof) || isTextArray || isString;
  return (
    <TouchableOpacity disabled={disabled} onPress={onPress}>
      <StaticButton
        // @ts-ignore
        hover={hover}
        active={active}
        onMouseDown={() => setActive(true)}
        onMouseUp={() => setActive(false)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => {
          setHover(false);
          setActive(false);
        }}
        disabled={disabled}
        sx={sx}
      >
        {renderString ? <ButtonText sx={textSx}>{children}</ButtonText> : children}
      </StaticButton>
    </TouchableOpacity>
  );
}

export const Button = memo(HB);

interface ButtonWithIconProps {
  text: string;
  image: JSX.Element;
  sx: any;
  textSx: any;
  onPress: (event: any) => void;
}

export function ButtonWithIcon({
  text,
  image,
  sx,
  textSx,
  onPress,
}: ButtonWithIconProps) {
  return (
    <Button sx={sx} onPress={onPress}>
      {image}
      <ButtonText sx={textSx}>{text}</ButtonText>
    </Button>
  );
}
